import { ValueRanges } from 'rlv-common';
import { object, ObjectSchema, Schema, number as yupNumber } from 'yup';
import { getCommonValidationParameters } from './CommonValidations';

export function constantSumInsuredValidation(valueRanges: ValueRanges): Schema<any> {
  return createConstantNeedBlockSchema(valueRanges)
    .concat(constantSumInsuredValidator(valueRanges))
    .concat(constantYearsTermValidator(valueRanges));
}

export function createConstantNeedBlockSchema(valueRanges: ValueRanges): Schema<any> {
  return getCommonValidationParameters(valueRanges);
}

export const constantSumInsuredValidator = (valueRanges: ValueRanges): ObjectSchema => {
  const {
    insuranceSum: { increment, max, min },
  } = valueRanges;

  const US_INCREMENT = 5000;

  const OUT_OF_RANGE_MSG = `Bitte wählen Sie eine Summe zwischen ${min.toLocaleString(
    'de-DE',
  )} und ${max.toLocaleString('de-DE')} € (in ${
    increment ? increment.toLocaleString('de-DE') : ''
  }er-Schritten).`;

  return object().shape({
    sumInsured: yupNumber()
      .required('Darf nicht leer sein')
      .min(min, OUT_OF_RANGE_MSG)
      .max(max, OUT_OF_RANGE_MSG)
      .test('Multiple', OUT_OF_RANGE_MSG, value => {
        if (increment) {
          return value % US_INCREMENT === 0;
        }
        return true;
      }),
  });
};

export const constantYearsTermValidator = (valueRanges: ValueRanges) => {
  const {
    insuranceDuration: { max, min },
  } = valueRanges;

  const OUT_OF_RANGE_MSG = `Bitte wählen Sie eine Laufzeit zwischen ${min} und ${max} Jahren.`;

  return object().shape({
    periodInYears: yupNumber()
      .required('Darf nicht leer sein.')
      .min(min, OUT_OF_RANGE_MSG)
      .max(max, OUT_OF_RANGE_MSG),
  });
};
